import { category as BudgetCategories } from '@/__generated__/requests/types.gen'

import { getBudgetCategoryIcon } from '@/helpers/getBudgetCategoryIcon.helper'
import { getSpentCategoryColor } from '@/helpers/getSpentCategoryColor.helper'
import { mapCategories } from '@/helpers/mapCategories.helper'

export const BUDGET_CATEGORIES = Object.values(BudgetCategories).map(
  category => ({
    color: getSpentCategoryColor(category),
    icon: getBudgetCategoryIcon(category),
    name: category,
  }),
)

// UNKNOWN is only auto-assigned to low-confidence transactions — it is not
// selectable as a budget category or as a manual transaction category.
export const BUDGET_CATEGORY_OPTIONS = BUDGET_CATEGORIES.filter(
  category => category.name !== BudgetCategories.UNKNOWN,
).map(category => ({
  label: mapCategories(category.name),
  value: category.name,
}))
